export default {"name":"NovaComponents-ContextMenu-gui-icu","NovaComponents-ContextMenu-gui-icu.loading.menuitem.label":"Loading menu…"}